export default __webpack_public_path__ + "static/media/vanguardLogo.a8776a70.png";